import moment from 'moment'

import {
  formatCurrency,
  formatDecimal,
  formatInteger
} from 'Components/UI/EAReport/utils/format'

import {
  REPORT_CURRENCY_TYPE,
  REPORT_DATE_TYPE,
  REPORT_DATETIME_TYPE,
  REPORT_DECIMAL_TYPE,
  REPORT_INTEGER_TYPE
} from 'Components/UI/EAReport/constants'

const adjustCurrency = (dataIndex) => (record) => {
  const value = record[dataIndex]

  return {
    ...record,
    [`${dataIndex}_csv`]: String(value).replace('.', ','),
    [`${dataIndex}_num`]: Number.isNaN(value) ? 0 : Number(value),
    [`${dataIndex}_str`]: formatCurrency(value)
  }
}

const adjustDate = (dataIndex) => (record) => {
  const aMomentDate = moment(record[dataIndex])
  const isValidDate = aMomentDate.isValid()

  return {
    ...record,
    [`${dataIndex}_str`]: isValidDate ? aMomentDate.format('DD/MM/yyyy') : '-',
    [`${dataIndex}_unix`]: isValidDate ? aMomentDate.unix() : 0
  }
}

const adjustDateTime = (dataIndex) => (record) => {
  const aMomentDate = moment(record[dataIndex])
  const isValidDate = aMomentDate.isValid()

  return {
    ...record,
    [`${dataIndex}_str`]: isValidDate
      ? aMomentDate.format('DD/MM/YYYY HH:mm:ss')
      : '-',
    [`${dataIndex}_unix`]: isValidDate ? aMomentDate.unix() : 0
  }
}

const adjustDecimal = (dataIndex) => (record) => {
  const value = record[dataIndex]

  return {
    ...record,
    [`${dataIndex}_csv`]: String(value).replace('.', ','),
    [`${dataIndex}_num`]: Number.isNaN(value) ? 0 : Number(value),
    [`${dataIndex}_str`]: formatDecimal(value)
  }
}

const adjustInteger = (dataIndex) => (record) => {
  const value = record[dataIndex]

  return {
    ...record,
    [`${dataIndex}_csv`]: String(value).replace('.', ','),
    [`${dataIndex}_num`]: Number.isNaN(value) ? 0 : Number(value),
    [`${dataIndex}_str`]: formatInteger(value)
  }
}

const adjustReportData = (columns, dataSource) => {
  let dataSourceCopy = [...dataSource]

  columns.forEach((column) => {
    const { dataIndex, type } = column

    if (type === REPORT_CURRENCY_TYPE) {
      dataSourceCopy = dataSourceCopy.map(adjustCurrency(dataIndex))
    }

    if (type === REPORT_DATE_TYPE) {
      dataSourceCopy = dataSourceCopy.map(adjustDate(dataIndex))
    }

    if (type === REPORT_DATETIME_TYPE) {
      dataSourceCopy = dataSourceCopy.map(adjustDateTime(dataIndex))
    }

    if (type === REPORT_DECIMAL_TYPE) {
      dataSourceCopy = dataSourceCopy.map(adjustDecimal(dataIndex))
    }

    if (type === REPORT_INTEGER_TYPE) {
      dataSourceCopy = dataSourceCopy.map(adjustInteger(dataIndex))
    }
  })

  return dataSourceCopy
}

export default adjustReportData
